import React from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const BookingBar = () => {
    const gradient = (ctx) => {
        const gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, "#3354F4"); 
        gradient.addColorStop(1, "#FFFFFF00"); 
        return gradient;
    };

    const borderColor = "#27648B"; 

    const data = {
        labels: [
            "01 Aug", "02 Aug", "03 Aug", "04 Aug", "07 Aug", "08 Aug", 
            "09 Aug", "10 Aug", "11 Aug", "14 Aug", "15 Aug", "16 Aug"
        ],
        datasets: [
            {
                label: "This Year",
                data: [100, 80, 60, 80, 60, 65, 80, 40, 60, 40, 60, 45, 60, 40, 80],
                borderColor: borderColor,
                backgroundColor: (context) => gradient(context.chart.ctx), 
                tension: 0.4, 
                fill: true,
                pointRadius: 5, 
                pointBackgroundColor: "#FFFFFF", 
                pointBorderColor: "#27648B", 
                pointBorderWidth: 1, 
                borderWidth: 2, 
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 20,
                    callback: (value) => `${value}%`, 
                },
            },
            x: {
                grid: {
                    display: false,
                },
            },
        },
        animation: {
            duration: 3000, 
            easing: "easeInOutCubic", 
        },
    };

    // Register the shadow plugin
    ChartJS.register({
        id: "shadowPlugin",
        beforeDatasetsDraw: (chart) => {
            const ctx = chart.ctx;

            // Loop through each dataset
            chart.data.datasets.forEach((dataset, index) => {
                const meta = chart.getDatasetMeta(index);
                const { data } = meta;

                if (meta.type === "line") {
                    ctx.save();

                    // Configure shadow properties
                    ctx.shadowColor = "rgba(51, 84, 244, 0.5)"; // Shadow color
                    ctx.shadowBlur = 20; // Blur intensity
                    ctx.shadowOffsetX = 0; // Horizontal offset
                    ctx.shadowOffsetY = 10; // Vertical offset

                    // Draw the shadow only
                    ctx.beginPath();
                    data.forEach((point, i) => {
                        const { x, y } = point;
                        if (i === 0) {
                            ctx.moveTo(x, y);
                        } else {
                            ctx.lineTo(x, y);
                        }
                    });
                    ctx.lineWidth = dataset.borderWidth;
                    ctx.strokeStyle = "rgba(0, 0, 0, 0)"; // Ensure no visible border is drawn for the shadow itself
                    ctx.stroke();

                    ctx.restore();
                }
            });
        },
    });

    return (
        <div className="w-[320px] lg:w-full p-4 sm:p-6 lg:p-8 bg-white rounded-lg shadow-md">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-[#252C58]">Booking Status</h2>
            </div>
            <div className="w-full h-[150px] sm:h-[300px] md:h-[350px] lg:h-[290px]">
                <Line data={data} options={options} />
            </div>
        </div>
    );
};

export default BookingBar;
